import { render, staticRenderFns } from "./JoinProject.vue?vue&type=template&id=067aa522"
import script from "./JoinProject.vue?vue&type=script&lang=js"
export * from "./JoinProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports